<template>
    <div class="row">
        <div class="col-md-6">
            <b-skeleton animation="fade" width="215px" height="14px" class="mb-3" />
            <b-skeleton animation="fade" height="19px"/>
            <b-skeleton animation="fade" :width="isMobile ? '100%': '50%'" height="19px" />
            <b-skeleton animation="fade" width="60px" v-if="isMobile" height="19px" />
            <b-card bg-variant="light" class="mt-3">
                <div class="row">
                    <div class="col-auto">
                        <b-skeleton-icon icon="square-fill" :icon-props="{ fontScale: 2 }" animation="fade" />
                    </div>
                    <div class="col">
                        <b-skeleton animation="fade" width="100px" height="11px" />
                        <b-skeleton animation="fade" width="100%" height="14px" />
                        <b-skeleton animation="fade" width="50px" height="14px" v-if="isMobile" />
                        <div class="row mt-3">
                            <div class="col-md-6 d-flex align-items-center">
                                <b-skeleton type="avatar" animation="fade" size="21px" class="float-left mr-2" />
                                <b-skeleton animation="fade" height="11px" width="100%" class="mb-0"/>
                            </div>
                            <div class="col-md-6 d-flex align-items-center mt-2 mt-md-0">
                                <b-skeleton type="avatar" animation="fade" size="21px" class="float-left mr-2" />
                                <b-skeleton animation="fade" height="11px" width="100%" class="mb-0"/>
                            </div>
                        </div>
                        <b-skeleton type="button" animation="fade" class="float-right mt-3" />
                    </div>
                </div>
            </b-card>
            <div class="d-flex justify-content-between align-items-center mt-3">
                <b-skeleton type="avatar" animation="fade" size="50px" />
                <b-skeleton animation="fade" width="100px" height="11px" />
            </div>
        </div>
        <div :class="['col-md-6 mt-3 mt-md-0', {'d-flex justify-content-center': isMobile}]">
            <b-skeleton-img animation="fade" :height="isMobile ? '130px' : '244px'" :width="isMobile ? '185px' : '100%'" />
        </div>
    </div>
</template>

<script>
    import mobileCheckMixin from "../../mixins/mobileCheckMixin";

    export default {
        name: "NextLearningUnitSkeleton",
        mixins: [mobileCheckMixin]
    }
</script>